export const getStoredCommitId = (key) => {
    return localStorage.getItem(key);
};
export const setStoredCommitId = (key, commitId) => {
    localStorage.setItem(key, commitId);
};
export const isAppOutdated = (key, commitId) => {
    return commitId !== getStoredCommitId(key);
};
export const updateStoredCommitId = (key, commitId) => {
    return setStoredCommitId(key, commitId);
};
//# sourceMappingURL=git-info-storage.js.map